module.exports = __webpack_public_path__ + "media/images/global/projects/social_studies-248a612dbb883154a66f2c188a1099b6.svg";